export default __webpack_public_path__ + "static/media/know-more-section.8bd8eaad.png";